import { Box } from '@mui/material';
import { GridFilterPanel } from '@mui/x-data-grid-pro';
import type { ComponentProps } from 'react';

export const SearchFilterPanel = (properties: ComponentProps<typeof GridFilterPanel>) => {
  return (
    <Box
      sx={{
        minWidth: 850,
        '& .MuiDataGrid-filterForm': {
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        },
        '& .MuiDataGrid-filterFormValueInput': {
          flex: 1,
        },
      }}
    >
      <GridFilterPanel {...properties} />
    </Box>
  );
};
